<template>

    <!-- <q-dialog v-model="showUpgradeAppVersionUser" persistent no-route-dismiss no-backdrop-dismiss no-esc-dismiss square> -->
    <q-dialog :model-value="user.app_version != utils?.app_version_str" persistent no-route-dismiss no-backdrop-dismiss no-esc-dismiss square>

        <q-card class="cursor-pointer text-center" @click="upgradeAppVersionUser()" flat bordered
                style="width: 250px">

            <q-card-section>

                <div v-if=" ! showTextLoad" class="q-animate--scale">

                    <p class="text-h6 text-center">Une mise à jour est disponible...</p>
                    <p class="q-mb-none">
                        <!-- <span class="text-warning">v{{ user.app_version }}</span>&nbsp;&nbsp;->&nbsp;&nbsp;<b class="text-positive">v{{ app_state().appversion }}</b> -->
						<span class="text-warning">v{{ user.app_version }}</span>&nbsp;&nbsp;->&nbsp;&nbsp;<b class="text-positive">v{{ utils?.app_version_str }}</b>

                        <Popup size="xs" padding="none" icon="info" class="q-ml-xs">
                            <p><small>Informations sur la nouvelle version :</small></p>
                            <p v-html="nl2br(utils.appversion?.info)"></p>
                        </Popup>
                    </p>

                    <MyAlert v-if="nb_tabsOpened > 1" type="warning" class="q-mt-md">
                        Vous avez {{ pluralize((nb_tabsOpened-1), 'autre onglet ouvert') }}...
                        <br/>
                        <b>Pensez à {{ pluralize((nb_tabsOpened-1), 'le', false) }} recharger également...</b>
                        <!-- <b>Veuillez {{ pluralize((nb_tabsOpened-1), 'le', false) }} fermer avant de procéder à la MàJ.</b> -->
                    </MyAlert>
                </div>

                <div v-else class="q-animate--scale">

                    <p>La page sera rechargée<br/>dans quelques instants...</p>
                    <p>
                        <!-- <q-spinner color="positive" size="xl" thickness="1" /> -->

                        <q-knob show-value :max="4" reverse
                                v-model="countdownAutoRefresh"
                                font-size="18px" class="text-bold text-positive q-ma-xs" :thickness="0.1" color="positive" readonly track-color="grey-3" size="xl">
                            {{ countdownAutoRefresh }}
                        </q-knob>
                    </p>
                </div>
            </q-card-section>

            <q-card-actions v-if=" ! showTextLoad" align="center">
                <q-btn label="Appliquer la Mise à Jour" color="positive" v-close-popup outline no-caps square class="full-width" />
            </q-card-actions>
        </q-card>

    </q-dialog>

</template>

<script setup>
import { pp, app_state, pp_user, refresh, nl2br, pluralize, getTabsOpenedNumber } from '@helpers'
import { ref } from "@vue/reactivity"
import { onMounted } from "@vue/runtime-core"


// const app_state = proto.$store.state.app

// const showUpgradeAppVersionUser = ref(true)

const showTextLoad = ref(false)

// log('1 in UpgradeAppVersionUser', proto.user, pp_user())

// onMounted(()=>{

//     if(//pp_user()?.app_version // un nouvel user n'a rien dans son 'app_version' ...
//         //  &&
//         pp_user()?.app_version != app_state().appversion
//     ){
//         showUpgradeAppVersionUser.value = true
//     }
// })

let countdownAutoRefresh = ref(4)

let nb_tabsOpened = ref(1)

onMounted( ()=>{

    //? pour que ça change les données en ouvrant/fermant un onglet

    nb_tabsOpened.value = getTabsOpenedNumber()

    window.addEventListener('storage', (event) => {
        if (event.key == app_state().tabsOpenKey/*  && Number(event.newValue) > 0 */) {
            nb_tabsOpened.value = getTabsOpenedNumber()
        }
    })
})

const upgradeAppVersionUser = () => {

    showTextLoad.value = true

    setInterval(() => {
        countdownAutoRefresh.value--
    }, 1000)


    _.delay(()=>{

        axios.post(route('upgrade-app-version-user'), {
            // app_version: app_state().appversion,
            app_version: pp().utils?.app_version_str,
        }).then(() => {

            // showUpgradeAppVersionUser.value = false

            refresh()// important - pour que ça recharge réellement la page
        })

    }, (countdownAutoRefresh.value * 1000))

}

</script>
